import "./Deals.css";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

// Controllers Start
import GetProperties from "../../controllers/properties/getProperties";
import GetDealsByStatus from "../../controllers/Enquiries/GetDealsByStatus";
import GetLeadsIncludesInArray from "../../controllers/leads/GetLeadsIncludesInArray";
import GetAgentsIncludesInArray from "../../controllers/agents/GetAgentsIncludesInArray";
import GetAdmin from "../../controllers/admin/GetAdmin";
import getSettings from "../../controllers/settings/getSettings";
// Controllers End

// Common Components Start
import Deal from "./Deal/Deal";
// Common Components End

// Functions Start
import { compareDesc } from "date-fns";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
// Functions End

import DealsCard from "../../components/Deals/DealsCard/DealsCard";
import NoDataFound from "../../components/Common/NoDataFound/NoDataFound";
import FabButton from "../../components/FabButton/FabButton";

const DEALS_LOT_SIZE = 5;

const Deals = () => {
  const navigate = useNavigate();
  // useStates Start
  const [agents, setAgents] = useState();
  const [leads, setLeads] = useState();
  const [UpdateEnquiryData, setUpdateEnquiryData] = useState(null);
  const [properties, setProperties] = useState([]);
  // useStates End

  // Enquiry Status States Start
  const [fetchingDeals, setFetchingDeals] = useState(true);
  const [hasMoreOpenDeals, setHasMoreOpenDeals] = useState(true);
  const [openDeals, setOpenDeals] = useState([]);
  const [hasMoreWonDeals, setHasMoreWonDeals] = useState(true);
  const [wonDeals, setWonDeals] = useState([]);
  const [hasMoreLostDeals, setHasMoreLostDeals] = useState(true);
  const [hasMoreAutoLostDeals, setHasMoreAutoLostDeals] = useState(true);

  const [lostDeals, setLostDeals] = useState([]);
  const [autolostDeals, setAutoLostDeals] = useState([]);

  const [Type, setType] = useState("*");

  useEffect(() => {
    /** When type changes, empty all deals arrays */
    setOpenDeals([]);
    setWonDeals([]);
    setLostDeals([]);
    setAutoLostDeals([]);
    setHasMoreOpenDeals(true);
    setHasMoreWonDeals(true);
    setHasMoreLostDeals(true);
    setHasMoreAutoLostDeals(true);
  }, [Type]);

  const GetOpenDeals = async (BottomFetching = true) => {
    const newOpenDeals = await GetDealsByStatus(
      "open",
      Type,
      openDeals.length,
      DEALS_LOT_SIZE
    );

    if (newOpenDeals.length < DEALS_LOT_SIZE) setHasMoreOpenDeals(false);
    if (BottomFetching) setOpenDeals([...openDeals, ...newOpenDeals]);
    else setOpenDeals([...newOpenDeals]);
  };
  const GetWonDeals = async (BottomFetching = true) => {
    const newWonDeals = await GetDealsByStatus(
      "won",
      Type,
      wonDeals.length,
      DEALS_LOT_SIZE
    );
    if (newWonDeals.length < DEALS_LOT_SIZE) setHasMoreWonDeals(false);
    if (BottomFetching) setWonDeals([...wonDeals, ...newWonDeals]);
    else setWonDeals([...newWonDeals]);
  };
  const GetLostDeals = async (BottomFetching = true) => {
    const newLostDeals = await GetDealsByStatus(
      "lost",
      Type,
      lostDeals.length,
      DEALS_LOT_SIZE
    );
    if (newLostDeals.length < DEALS_LOT_SIZE) setHasMoreLostDeals(false);
    if (BottomFetching) setLostDeals([...lostDeals, ...newLostDeals]);
    else setLostDeals([...newLostDeals]);
  };
  const GetAutoLostDeals = async (BottomFetching = true) => {
    const newAutoLostDeals = await GetDealsByStatus(
      "Auto Lost",
      Type,
      autolostDeals.length,
      DEALS_LOT_SIZE
    );
    if (newAutoLostDeals.length < DEALS_LOT_SIZE)
      setHasMoreAutoLostDeals(false);
    if (BottomFetching)
      setAutoLostDeals([...autolostDeals, ...newAutoLostDeals]);
    else setAutoLostDeals([...newAutoLostDeals]);
  };
  // Deals useEffect Start
  useEffect(() => {
    (async () => {
      setHasMoreOpenDeals(true);
      setHasMoreWonDeals(true);
      setHasMoreLostDeals(true);
      setHasMoreAutoLostDeals(true);
      setFetchingDeals(true);
      GetOpenDeals(false);
      GetWonDeals(false);
      GetLostDeals(false);
      GetAutoLostDeals(false);
      setFetchingDeals(false);
    })();
  }, [Type]);
  // Deals useEffect End

  // Leads useEffect Start
  useEffect(() => {
    (async () => {
      let arrayOfLeadsIds = [];

      /** Getting ids of leads in deals */
      openDeals.forEach(({ client }) => arrayOfLeadsIds.push(client));
      wonDeals.forEach(({ client }) => arrayOfLeadsIds.push(client));
      lostDeals.forEach(({ client }) => arrayOfLeadsIds.push(client));

      arrayOfLeadsIds = Array.from(new Set(arrayOfLeadsIds));

      const d = await GetLeadsIncludesInArray(arrayOfLeadsIds);
      setLeads(d);
    })();
  }, [openDeals, wonDeals, lostDeals]);
  // Leads useEffect End

  // Agents useEffect Start
  useEffect(() => {
    (async () => {
      let arrayOfAgentsIds = [];

      /** Getting ids of agent in deals */
      openDeals.forEach(({ agent }) => arrayOfAgentsIds.push(agent));
      wonDeals.forEach(({ agent }) => arrayOfAgentsIds.push(agent));
      lostDeals.forEach(({ agent }) => arrayOfAgentsIds.push(agent));

      arrayOfAgentsIds = Array.from(new Set(arrayOfAgentsIds));

      const d = await GetAgentsIncludesInArray(arrayOfAgentsIds);
      d?.unshift(await GetAdmin());
      /**   */
      setAgents(d);
    })();
  }, [openDeals, wonDeals, lostDeals]);
  // Agents useEffect End

  // Properties useEffect Start
  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        let properties = await GetProperties(uid);

        properties = properties.map((e) => {
          return {
            ...e,
            thumbnail:
              "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general_images%2FloadingImg.gif?alt=media&token=9b58ee8f-4f7a-4757-8705-d004f7d5d3b1",
          };
        });

        const TotalProperties = properties.length;
        let TargetProperty = 1;

        const getImagesArray = async () => {
          const { id } = properties[TargetProperty] ?? {};
          const { items } = await listAll(
            ref(getStorage(), `/properties/${id}`)
          );
          let thumbnail;
          if (items.length !== 0) thumbnail = await getDownloadURL(items[0]);
          else
            thumbnail =
              "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general_images%2Fproperty-avatar.jpg?alt=media&token=76422344-c1de-4415-a036-b7e62e8c06de";

          properties[TargetProperty] = {
            ...properties[TargetProperty],
            thumbnail,
          };

          if (++TargetProperty >= TotalProperties) return;
          else await getImagesArray();
        };

        if (properties.length > 0) await getImagesArray();

        setProperties([...properties]);
      });
    }
    fetchData();
  }, [Type]);
  // Properties useEffect End

  // Sort Deals Object To Edit Start
  const SetEnquiryObjToEdit = (status, index) => {
    if (status === null || index === null) return null;
    let toReturn = null;
    switch (status) {
      case "open":
        toReturn = openDeals[index];
        break;
      case "won":
        toReturn = wonDeals[index];
        break;
      case "lost":
        toReturn = lostDeals[index];
        break;
      default:
        return "";
    }
    setUpdateEnquiryData(toReturn);
  };
  // Sort Deals Object To Edit End

  const sortEnquiriesArray = (arr) =>
    arr.sort((a, b) =>
      compareDesc(
        new Date(a.createdAt.toDate()),
        new Date(b.createdAt.toDate())
      )
    );

  // Currency Settings UseEffect Start
  const [CurrencySettings, setCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setCurrencySettings(settings);
    }
    fetchData();
  }, []);
  // Currency Settings UseEffect End

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  const [DealStatus, setDealStatus] = useState("open");

  return (
    <Fragment>
      {isMobile && (
        <FabButton
          onClick={() => {
            navigate("/user/deals/add");
          }}
        />
      )}
      <div className="global-body-container deals-listing-page">
        {isMobile ? (
          <>
            <div className="mobile-screen-deals-listing-filters-header">
              <div className="custom-heading">Deals</div>
              <div className="mobile-screen-deals-listing-filters-container">
                <div
                  className={`${
                    Type === "*" ? "active-filter" : "in-active-filter"
                  }`}
                  onClick={() => setType("*")}
                >
                  All
                </div>
                <div
                  className={`${
                    Type === "buy" ? "active-filter" : "in-active-filter"
                  }`}
                  onClick={() => setType("buy")}
                >
                  Buy
                </div>
                <div
                  className={`${
                    Type === "sale" ? "active-filter" : "in-active-filter"
                  }`}
                  onClick={() => setType("sale")}
                >
                  Sale
                </div>
                <div
                  className={`${
                    Type === "rent" ? "active-filter" : "in-active-filter"
                  }`}
                  onClick={() => setType("rent")}
                >
                  Rent
                </div>
              </div>
            </div>
            <div className="mobile-screen-deals-listing-container">
              <div className="mobile-screen-deals-listing-type-buttons-container">
                <button
                  onClick={() => setDealStatus("open")}
                  className={`${
                    DealStatus === "open"
                      ? "active-open-type-button"
                      : "open-type-button"
                  }`}
                >
                  Open( {openDeals?.length ? openDeals?.length + " " : 0 + " "})
                </button>
                <button
                  onClick={() => setDealStatus("won")}
                  className={`${
                    DealStatus === "won"
                      ? "active-won-type-button"
                      : "won-type-button"
                  }`}
                >
                  Won( {wonDeals?.length ? wonDeals?.length + " " : 0 + " "})
                </button>
                <button
                  onClick={() => setDealStatus("lost")}
                  className={`${
                    DealStatus === "lost"
                      ? "active-lost-type-button"
                      : "lost-type-button"
                  }`}
                >
                  Lost( {lostDeals?.length ? lostDeals?.length + " " : 0 + " "})
                </button>
                <button
                  onClick={() => setDealStatus("archived")}
                  className={`${
                    DealStatus === "archived"
                      ? "active-archived-type-button"
                      : "archived-type-button"
                  }`}
                >
                  Archived({autolostDeals?.length ? autolostDeals?.length : "0"}
                  )
                </button>
              </div>
              <div className="mobile-screen-deals-listing-content">
                <>
                  {!fetchingDeals &&
                    DealStatus === "open" &&
                    openDeals?.length === 0 &&
                    !hasMoreOpenDeals && (
                      <div className="mobile-screen-deals-no-data-svg">
                        <NoDataFound />
                      </div>
                    )}

                  {DealStatus === "open" &&
                    sortEnquiriesArray(openDeals).map((openDeal, index) => {
                      const propertyObj = properties.filter(
                        (p) => p !== openDeal.property.id
                      );
                      const propertyThumbnail = propertyObj.map((thumb) => {
                        return thumb.thumbnail;
                      });

                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = openDeal;
                      return (
                        <DealsCard
                          onClick={() => {
                            navigate(`/user/deals/update/${id}`);
                          }}
                          id={id}
                          key={id}
                          agent={agent.id}
                          status={currentstatus}
                          interest={interest}
                          lead={client.id}
                          property={property.id}
                          createdAt={createdAt}
                          // transaction = "",
                          // name = "",
                          dealPrice={dealPrice}
                          thumbnail={
                            property.images
                              ? property.images[0]
                              : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                          }
                          CurrencySettings={CurrencySettings}
                        />
                      );
                    })}

                  {!fetchingDeals &&
                    DealStatus === "won" &&
                    wonDeals.length === 0 &&
                    !hasMoreWonDeals && (
                      <div className="mobile-screen-deals-no-data-svg">
                        <NoDataFound />
                      </div>
                    )}
                  {DealStatus === "won" &&
                    sortEnquiriesArray(wonDeals).map((wonDeal, index) => {
                      const propertyObj = properties.filter(
                        (p) => p !== wonDeal.property.id
                      );
                      const propertyThumbnail = propertyObj.map((thumb) => {
                        return thumb.thumbnail;
                      });
                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = wonDeal;
                      return (
                        <DealsCard
                          onClick={() => {
                            navigate(`/user/deals/update/${id}`);
                          }}
                          id={id}
                          key={id}
                          agent={agent.id}
                          status={currentstatus}
                          interest={interest}
                          lead={client.id}
                          property={property.id}
                          createdAt={createdAt}
                          // transaction = "",
                          // name = "",
                          dealPrice={dealPrice}
                          thumbnail={
                            property.images
                              ? property.images[0]
                              : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                          }
                          CurrencySettings={CurrencySettings}
                        />
                      );
                    })}

                  {!fetchingDeals &&
                    DealStatus === "lost" &&
                    lostDeals.length === 0 &&
                    !hasMoreLostDeals && (
                      <div className="mobile-screen-deals-no-data-svg">
                        <NoDataFound />
                      </div>
                    )}
                  {DealStatus === "lost" &&
                    sortEnquiriesArray(lostDeals).map((lostDeal, index) => {
                      const propertyObj = properties.filter(
                        (p) => p !== lostDeal.property.id
                      );
                      const propertyThumbnail = propertyObj.map((thumb) => {
                        return thumb.thumbnail;
                      });
                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = lostDeal;
                      return (
                        <DealsCard
                          onClick={() => {
                            navigate(`/user/deals/update/${id}`);
                          }}
                          id={id}
                          key={id}
                          agent={agent.id}
                          status={currentstatus}
                          interest={interest}
                          lead={client.id}
                          property={property.id}
                          createdAt={createdAt}
                          // transaction = "",
                          // name = "",
                          dealPrice={dealPrice}
                          thumbnail={
                            property.images
                              ? property.images[0]
                              : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                          }
                          CurrencySettings={CurrencySettings}
                        />
                      );
                    })}

                  {!fetchingDeals &&
                    DealStatus === "archived" &&
                    autolostDeals.length === 0 &&
                    !hasMoreAutoLostDeals && (
                      <div className="mobile-screen-deals-no-data-svg">
                        <NoDataFound />
                      </div>
                    )}
                  {DealStatus === "archived" &&
                    sortEnquiriesArray(autolostDeals).map(
                      (autolostDeal, index) => {
                        const propertyObj = properties.filter(
                          (p) => p !== autolostDeal.property.id
                        );
                        const propertyThumbnail = propertyObj.map((thumb) => {
                          return thumb.thumbnail;
                        });
                        const {
                          agent,
                          comments,
                          currentstatus,
                          interest,
                          client,
                          property,
                          createdAt,
                          transaction,
                          id,
                          dealPrice,
                        } = autolostDeal;
                        return (
                          <DealsCard
                            onClick={() => {
                              navigate(`/user/deals/update/${id}`);
                            }}
                            id={id}
                            key={id}
                            agent={agent.id}
                            status={currentstatus}
                            interest={interest}
                            lead={client.id}
                            property={property.id}
                            createdAt={createdAt}
                            // transaction = "",
                            // name = "",
                            dealPrice={dealPrice}
                            thumbnail={
                              property.images
                                ? property.images[0]
                                : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                            }
                            CurrencySettings={CurrencySettings}
                          />
                        );
                      }
                    )}
                </>
              </div>
            </div>
          </>
        ) : (
          <>
            <div id="deals-listing-header">
              <div className="deals-listing title">
                <h2 className="custom-heading">Deals</h2>
                <div className="links-style ">
                  <a
                    href="#"
                    className={`link-tab ${Type === "*" ? "active" : ""}`}
                    onClick={() => setType("*")}
                  >
                    All
                  </a>
                  <a
                    href="#"
                    className={`link-tab ${Type === "buy" ? "active" : ""}`}
                    onClick={() => setType("buy")}
                  >
                    Buy
                  </a>
                  <a
                    href="#"
                    className={`link-tab ${Type === "sale" ? "active" : ""}`}
                    onClick={() => setType("sale")}
                  >
                    Sale
                  </a>
                  <a
                    href="#"
                    className={`link-tab ${Type === "rent" ? "active" : ""}`}
                    onClick={() => setType("rent")}
                  >
                    Rent
                  </a>
                </div>
              </div>

              <div className="deals-listing-buttons">
                <button
                  className="add-deal-button"
                  type="button"
                  onClick={() => {
                    navigate("/user/deals/add");
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 17V7"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7 12H17"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                  Add deal
                </button>
              </div>
            </div>

            {/* *All Deals*/}
            <div className="" id="all-deals-list-container">
              <div className="deal-card-list">
                <div
                  className="deal-card-list-header"
                  onClick={() => {
                    navigate("/user/deals/open");
                  }}
                >
                  <div className="deal-type-title">Open</div>
                  <div className="deal-type-count">
                    {openDeals?.length ? openDeals?.length + " " : 0 + " "}
                    {openDeals?.length === 0
                      ? "Deals"
                      : openDeals?.length > 1
                      ? "Deals"
                      : "Deal"}
                  </div>
                </div>

                <InfiniteScroll
                  dataLength={openDeals.length}
                  next={GetOpenDeals}
                  // hasMore={hasMoreOpenDeals}
                  loader={<ContentLoaderCustom />}
                  scrollThreshold={1}
                >
                  <div className="deal-card-list-body">
                    {!fetchingDeals &&
                      openDeals?.length === 0 &&
                      !hasMoreOpenDeals && (
                        <div className="deals-no-data-svg">
                          <NoDataFound />
                        </div>
                      )}
                    {sortEnquiriesArray(openDeals).map((openDeal, index) => {
                      const propertyObj = properties.filter(
                        (p) => p !== openDeal.property.id
                      );
                      const propertyThumbnail = propertyObj.map((thumb) => {
                        return thumb.thumbnail;
                      });

                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = openDeal;
                      return (
                        <DealsCard
                          onClick={() => {
                            navigate(`/user/deals/update/${id}`);
                          }}
                          id={id}
                          key={id}
                          agent={agent.id}
                          status={currentstatus}
                          interest={interest}
                          lead={client.id}
                          property={property.id}
                          createdAt={createdAt}
                          // transaction = "",
                          // name = "",
                          dealPrice={dealPrice}
                          thumbnail={
                            property.images
                              ? property.images[0]
                              : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                          }
                          CurrencySettings={CurrencySettings}
                        />
                      );
                    })}
                  </div>
                </InfiniteScroll>
              </div>
              <div className="deal-card-list">
                <div
                  className="deal-card-list-header"
                  onClick={() => {
                    navigate("/user/deals/won");
                  }}
                >
                  <div className="deal-type-title">Won</div>
                  <div className="deal-type-count">
                    {wonDeals?.length ? wonDeals?.length + " " : 0 + " "}
                    {wonDeals?.length === 0
                      ? "Deals"
                      : wonDeals?.length > 1
                      ? "Deals"
                      : "Deal"}
                  </div>
                </div>

                <InfiniteScroll
                  dataLength={wonDeals.length} //This is important field to render the next data
                  next={GetWonDeals}
                  // hasMore={hasMoreWonDeals}
                  loader={<ContentLoaderCustom />}
                  scrollThreshold={1}
                >
                  <div className="deal-card-list-body">
                    {!fetchingDeals &&
                      wonDeals.length === 0 &&
                      !hasMoreWonDeals && (
                        <div className="deals-no-data-svg">
                          <NoDataFound />
                        </div>
                      )}
                    {sortEnquiriesArray(wonDeals).map((wonDeal, index) => {
                      const propertyObj = properties.filter(
                        (p) => p !== wonDeal.property.id
                      );
                      const propertyThumbnail = propertyObj.map((thumb) => {
                        return thumb.thumbnail;
                      });
                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = wonDeal;
                      return (
                        <DealsCard
                          onClick={() => {
                            navigate(`/user/deals/update/${id}`);
                          }}
                          id={id}
                          key={id}
                          agent={agent.id}
                          status={currentstatus}
                          interest={interest}
                          lead={client.id}
                          property={property.id}
                          createdAt={createdAt}
                          // transaction = "",
                          // name = "",
                          dealPrice={dealPrice}
                          thumbnail={
                            property.images
                              ? property.images[0]
                              : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                          }
                          CurrencySettings={CurrencySettings}
                        />
                      );
                    })}
                  </div>
                </InfiniteScroll>
              </div>
              <div className="deal-card-list">
                <div
                  className="deal-card-list-header"
                  onClick={() => {
                    navigate("/user/deals/lost");
                  }}
                >
                  <div className="deal-type-title">Lost</div>
                  <div className="deal-type-count">
                    {lostDeals?.length ? lostDeals?.length + " " : 0 + " "}

                    {lostDeals?.length === 0
                      ? "Deals"
                      : lostDeals?.length > 1
                      ? "Deals"
                      : "Deal"}
                  </div>
                </div>

                <InfiniteScroll
                  dataLength={lostDeals.length} //This is important field to render the next data
                  next={GetLostDeals}
                  // hasMore={hasMoreLostDeals}
                  loader={<ContentLoaderCustom />}
                  scrollThreshold={1}
                >
                  <div className="deal-card-list-body">
                    {!fetchingDeals &&
                      lostDeals.length === 0 &&
                      !hasMoreLostDeals && (
                        <div className="deals-no-data-svg">
                          <NoDataFound />
                        </div>
                      )}
                    {sortEnquiriesArray(lostDeals).map((lostDeal, index) => {
                      const propertyObj = properties.filter(
                        (p) => p !== lostDeal.property.id
                      );
                      const propertyThumbnail = propertyObj.map((thumb) => {
                        return thumb.thumbnail;
                      });
                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = lostDeal;
                      return (
                        <DealsCard
                          onClick={() => {
                            navigate(`/user/deals/update/${id}`);
                          }}
                          id={id}
                          key={id}
                          agent={agent.id}
                          status={currentstatus}
                          interest={interest}
                          lead={client.id}
                          property={property.id}
                          createdAt={createdAt}
                          // transaction = "",
                          // name = "",
                          dealPrice={dealPrice}
                          thumbnail={
                            property.images
                              ? property.images[0]
                              : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                          }
                          CurrencySettings={CurrencySettings}
                        />
                      );
                    })}
                  </div>
                </InfiniteScroll>
              </div>
              <div className="deal-card-list">
                <div
                  className="deal-card-list-header"
                  onClick={() => {
                    navigate("/user/deals/autolost");
                  }}
                >
                  <div className="deal-type-title">Archived</div>
                  <div className="deal-type-count">
                    {autolostDeals?.length
                      ? autolostDeals?.length + " "
                      : 0 + " "}
                    {autolostDeals?.length === 0
                      ? "Deals"
                      : autolostDeals?.length > 1
                      ? "Deals"
                      : "Deal"}
                  </div>
                </div>

                <InfiniteScroll
                  dataLength={autolostDeals.length} //This is important field to render the next data
                  next={GetAutoLostDeals}
                  // hasMore={hasMoreAutoLostDeals}
                  loader={<ContentLoaderCustom />}
                  scrollThreshold={1}
                >
                  <div className="deal-card-list-body">
                    {!fetchingDeals &&
                      autolostDeals.length === 0 &&
                      !hasMoreAutoLostDeals && (
                        <div className="deals-no-data-svg">
                          <NoDataFound />
                        </div>
                      )}
                    {sortEnquiriesArray(autolostDeals).map(
                      (autolostDeal, index) => {
                        const propertyObj = properties.filter(
                          (p) => p !== autolostDeal.property.id
                        );
                        const propertyThumbnail = propertyObj.map((thumb) => {
                          return thumb.thumbnail;
                        });
                        const {
                          agent,
                          comments,
                          currentstatus,
                          interest,
                          client,
                          property,
                          createdAt,
                          transaction,
                          id,
                          dealPrice,
                        } = autolostDeal;
                        return (
                          <DealsCard
                            onClick={() => {
                              navigate(`/user/deals/update/${id}`);
                            }}
                            id={id}
                            key={id}
                            agent={agent.id}
                            status={currentstatus}
                            interest={interest}
                            lead={client.id}
                            property={property.id}
                            createdAt={createdAt}
                            // transaction = "",
                            // name = "",
                            dealPrice={dealPrice}
                            thumbnail={
                              property.images
                                ? property.images[0]
                                : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                            }
                            CurrencySettings={CurrencySettings}
                          />
                        );
                      }
                    )}
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          </>
        )}
      </div>
    </Fragment>
  );
};

const ContentLoaderCustom = () => {
  return (
    // <div className="global-body-container  bg-transparent">
    <div className="sk-three-bounce deals-loader-container">
      <>
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </>
    </div>
    // </div>
  );
};

export default Deals;
